var _module_exports = "<div class=\"tr-dialog-background\" ng-click=\"close($event)\" ng-hide=\"hidden\">\n    <div class=\"tr-dialog\">\n        <ng-transclude></ng-transclude>\n    </div>\n</div>\n";;
var path = '/src/Client/Directives/dialog/dialog.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;